/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as LobbyRouteImport } from './routes/lobby'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAddonsRouteImport } from './routes/admin/addons'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminClaimsRouteImport } from './routes/admin/claims'
import { Route as AdminCredentialsRouteImport } from './routes/admin/credentials'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminFeaturesRouteImport } from './routes/admin/features'
import { Route as AdminJobsRouteImport } from './routes/admin/jobs'
import { Route as AdminMergeRouteImport } from './routes/admin/merge'
import { Route as AdminRatesRouteImport } from './routes/admin/rates'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminSanctionsRouteImport } from './routes/admin/sanctions'
import { Route as AdminSeedRouteImport } from './routes/admin/seed'
import { Route as AdminSettlementRouteImport } from './routes/admin/settlement'
import { Route as AdminStaffRouteImport } from './routes/admin/staff'
import { Route as AdminWatchlistRouteImport } from './routes/admin/watchlist'
import { Route as ContentPreviewIdRouteImport } from './routes/content-preview.$id'
import { Route as DevUiRouteImport } from './routes/dev.ui'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as PortalAnnouncementsRouteImport } from './routes/portal/announcements'
import { Route as PortalCompanyRouteImport } from './routes/portal/company'
import { Route as PortalNotificationsRouteImport } from './routes/portal/notifications'
import { Route as PortalTeamRouteImport } from './routes/portal/team'
import { Route as PortalTrustRouteImport } from './routes/portal/trust'
import { Route as PortalVerificationRouteImport } from './routes/portal/verification'
import { Route as PublicBlConfirmTokenRouteImport } from './routes/_public/bl-confirm.$token'
import { Route as PublicCSlugRouteImport } from './routes/_public/c.$slug'
import { Route as PublicEventsIndexRouteImport } from './routes/_public/events.index'
import { Route as PublicEventsSlugRouteImport } from './routes/_public/events.$slug'
import { Route as PublicQuoteTokenRouteImport } from './routes/_public/quote.$token'
import { Route as PublicSignInIndexRouteImport } from './routes/_public/sign-in.index'
import { Route as PublicSignInCallbackRouteImport } from './routes/_public/sign-in.callback'
import { Route as AdminCatalogueIndexRouteImport } from './routes/admin/catalogue.index'
import { Route as AdminCatalogueFxRouteImport } from './routes/admin/catalogue.fx'
import { Route as AdminCataloguePlatformChargeItemsRouteImport } from './routes/admin/catalogue.platform-charge-items'
import { Route as AdminCatalogueReferenceRouteImport } from './routes/admin/catalogue.reference'
import { Route as AdminCommunityIndexRouteImport } from './routes/admin/community.index'
import { Route as AdminContentIndexRouteImport } from './routes/admin/content.index'
import { Route as AdminContentMediaRouteImport } from './routes/admin/content.media'
import { Route as AdminContentMenusRouteImport } from './routes/admin/content.menus'
import { Route as AdminContentSettingsRouteImport } from './routes/admin/content.settings'
import { Route as AdminDirectoryIndexRouteImport } from './routes/admin/directory.index'
import { Route as AdminDisputesIndexRouteImport } from './routes/admin/disputes.index'
import { Route as AdminOperationsRfqRouteImport } from './routes/admin/operations.rfq'
import { Route as AdminOrgsIndexRouteImport } from './routes/admin/orgs.index'
import { Route as AdminOrgsIdRouteImport } from './routes/admin/orgs.$id'
import { Route as AdminPlansIndexRouteImport } from './routes/admin/plans.index'
import { Route as AdminPlansIdRouteImport } from './routes/admin/plans.$id'
import { Route as AdminUsageIndexRouteImport } from './routes/admin/usage.index'
import { Route as AdminUsageOrgIdRouteImport } from './routes/admin/usage.$orgId'
import { Route as AdminVerificationIndexRouteImport } from './routes/admin/verification.index'
import { Route as AdminVerificationOrgIdRouteImport } from './routes/admin/verification.$orgId'
import { Route as PortalBillingIndexRouteImport } from './routes/portal/billing.index'
import { Route as PortalBillingPlansRouteImport } from './routes/portal/billing.plans'
import { Route as PortalBillsIndexRouteImport } from './routes/portal/bills.index'
import { Route as PortalCatalogueIndexRouteImport } from './routes/portal/catalogue.index'
import { Route as PortalCatalogueChargeItemsRouteImport } from './routes/portal/catalogue.charge-items'
import { Route as PortalCatalogueFeeBundlesRouteImport } from './routes/portal/catalogue.fee-bundles'
import { Route as PortalCatalogueFxRouteImport } from './routes/portal/catalogue.fx'
import { Route as PortalClassifierIndexRouteImport } from './routes/portal/classifier.index'
import { Route as PortalCompaniesSlugRouteImport } from './routes/portal/companies.$slug'
import { Route as PortalConnectionsIndexRouteImport } from './routes/portal/connections.index'
import { Route as PortalConnectionsIdRouteImport } from './routes/portal/connections.$id'
import { Route as PortalDirectoryIndexRouteImport } from './routes/portal/directory.index'
import { Route as PortalDirectoryOrgIdRouteImport } from './routes/portal/directory.$orgId'
import { Route as PortalDirectoryProfileRouteImport } from './routes/portal/directory.profile'
import { Route as PortalDisputesIndexRouteImport } from './routes/portal/disputes.index'
import { Route as PortalDisputesIdRouteImport } from './routes/portal/disputes.$id'
import { Route as PortalDocumentsIndexRouteImport } from './routes/portal/documents.index'
import { Route as PortalDocumentsIdRouteImport } from './routes/portal/documents.$id'
import { Route as PortalDocumentsLetterheadRouteImport } from './routes/portal/documents.letterhead'
import { Route as PortalDutyIndexRouteImport } from './routes/portal/duty.index'
import { Route as PortalEventsIndexRouteImport } from './routes/portal/events.index'
import { Route as PortalEventsIdRouteImport } from './routes/portal/events.$id'
import { Route as PortalInvoicesIndexRouteImport } from './routes/portal/invoices.index'
import { Route as PortalMessagesIndexRouteImport } from './routes/portal/messages.index'
import { Route as PortalMessagesThreadIdRouteImport } from './routes/portal/messages.$threadId'
import { Route as PortalOffersIndexRouteImport } from './routes/portal/offers.index'
import { Route as PortalOffersIdRouteImport } from './routes/portal/offers.$id'
import { Route as PortalOffersNewRouteImport } from './routes/portal/offers.new'
import { Route as PortalPaymentRequestsIndexRouteImport } from './routes/portal/payment-requests.index'
import { Route as PortalRatesIndexRouteImport } from './routes/portal/rates.index'
import { Route as PortalRatesIdRouteImport } from './routes/portal/rates.$id'
import { Route as PortalRatesMineRouteImport } from './routes/portal/rates.mine'
import { Route as PortalRatesSharingRouteImport } from './routes/portal/rates.sharing'
import { Route as PortalRatesSurchargesRouteImport } from './routes/portal/rates.surcharges'
import { Route as PortalRfqIndexRouteImport } from './routes/portal/rfq.index'
import { Route as PortalRfqIdRouteImport } from './routes/portal/rfq.$id'
import { Route as PortalRfqNewRouteImport } from './routes/portal/rfq.new'
import { Route as PortalSettlementCashRouteImport } from './routes/portal/settlement.cash'
import { Route as PortalSettlementLedgerRouteImport } from './routes/portal/settlement.ledger'
import { Route as PortalSettlementManualPaymentsRouteImport } from './routes/portal/settlement.manual-payments'
import { Route as PortalSettlementPayRouteImport } from './routes/portal/settlement.pay'
import { Route as PortalSettlementReconciliationRouteImport } from './routes/portal/settlement.reconciliation'
import { Route as PortalShipmentsIndexRouteImport } from './routes/portal/shipments.index'
import { Route as PortalShipmentsIdRouteImport } from './routes/portal/shipments.$id'
import { Route as PortalShipmentsBookingRouteImport } from './routes/portal/shipments.booking'
import { Route as PortalShipmentsCollaborationRouteImport } from './routes/portal/shipments.collaboration'
import { Route as PortalShipmentsNewRouteImport } from './routes/portal/shipments.new'
import { Route as PortalTrackingIndexRouteImport } from './routes/portal/tracking.index'
import { Route as PortalTrackingPreferencesRouteImport } from './routes/portal/tracking.preferences'
import { Route as AdminCommunityEventsIdRouteImport } from './routes/admin/community.events.$id'
import { Route as AdminContentPagesIdRouteImport } from './routes/admin/content.pages.$id'
import { Route as AdminDirectoryProfilesOrgIdRouteImport } from './routes/admin/directory.profiles.$orgId'
import { Route as PortalMessagesPopoutThreadIdRouteImport } from './routes/portal/messages.popout.$threadId'
import { Route as PortalRatesImportsIdRouteImport } from './routes/portal/rates.imports.$id'
import { Route as PortalRatesQuotesIndexRouteImport } from './routes/portal/rates.quotes.index'
import { Route as PortalRatesQuotesIdRouteImport } from './routes/portal/rates.quotes.$id'
import { Route as PortalSettlementWriteoffsIdRouteImport } from './routes/portal/settlement.writeoffs.$id'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LobbyRoute = LobbyRouteImport.update({
  id: '/lobby',
  path: '/lobby',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAddonsRoute = AdminAddonsRouteImport.update({
  id: '/addons',
  path: '/addons',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClaimsRoute = AdminClaimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCredentialsRoute = AdminCredentialsRouteImport.update({
  id: '/credentials',
  path: '/credentials',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeaturesRoute = AdminFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsRoute = AdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMergeRoute = AdminMergeRouteImport.update({
  id: '/merge',
  path: '/merge',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRatesRoute = AdminRatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSanctionsRoute = AdminSanctionsRouteImport.update({
  id: '/sanctions',
  path: '/sanctions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSeedRoute = AdminSeedRouteImport.update({
  id: '/seed',
  path: '/seed',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettlementRoute = AdminSettlementRouteImport.update({
  id: '/settlement',
  path: '/settlement',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStaffRoute = AdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWatchlistRoute = AdminWatchlistRouteImport.update({
  id: '/watchlist',
  path: '/watchlist',
  getParentRoute: () => AdminRoute,
} as any)
const ContentPreviewIdRoute = ContentPreviewIdRouteImport.update({
  id: '/content-preview/$id',
  path: '/content-preview/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DevUiRoute = DevUiRouteImport.update({
  id: '/dev/ui',
  path: '/dev/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAnnouncementsRoute = PortalAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => PortalRoute,
} as any)
const PortalCompanyRoute = PortalCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => PortalRoute,
} as any)
const PortalNotificationsRoute = PortalNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => PortalRoute,
} as any)
const PortalTeamRoute = PortalTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => PortalRoute,
} as any)
const PortalTrustRoute = PortalTrustRouteImport.update({
  id: '/trust',
  path: '/trust',
  getParentRoute: () => PortalRoute,
} as any)
const PortalVerificationRoute = PortalVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => PortalRoute,
} as any)
const PublicBlConfirmTokenRoute = PublicBlConfirmTokenRouteImport.update({
  id: '/bl-confirm/$token',
  path: '/bl-confirm/$token',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCSlugRoute = PublicCSlugRouteImport.update({
  id: '/c/$slug',
  path: '/c/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const PublicEventsIndexRoute = PublicEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicEventsSlugRoute = PublicEventsSlugRouteImport.update({
  id: '/events/$slug',
  path: '/events/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const PublicQuoteTokenRoute = PublicQuoteTokenRouteImport.update({
  id: '/quote/$token',
  path: '/quote/$token',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInIndexRoute = PublicSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInCallbackRoute = PublicSignInCallbackRouteImport.update({
  id: '/sign-in/callback',
  path: '/sign-in/callback',
  getParentRoute: () => PublicRoute,
} as any)
const AdminCatalogueIndexRoute = AdminCatalogueIndexRouteImport.update({
  id: '/catalogue/',
  path: '/catalogue/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCatalogueFxRoute = AdminCatalogueFxRouteImport.update({
  id: '/catalogue/fx',
  path: '/catalogue/fx',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCataloguePlatformChargeItemsRoute =
  AdminCataloguePlatformChargeItemsRouteImport.update({
    id: '/catalogue/platform-charge-items',
    path: '/catalogue/platform-charge-items',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCatalogueReferenceRoute = AdminCatalogueReferenceRouteImport.update({
  id: '/catalogue/reference',
  path: '/catalogue/reference',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCommunityIndexRoute = AdminCommunityIndexRouteImport.update({
  id: '/community/',
  path: '/community/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentIndexRoute = AdminContentIndexRouteImport.update({
  id: '/content/',
  path: '/content/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentMediaRoute = AdminContentMediaRouteImport.update({
  id: '/content/media',
  path: '/content/media',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentMenusRoute = AdminContentMenusRouteImport.update({
  id: '/content/menus',
  path: '/content/menus',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentSettingsRoute = AdminContentSettingsRouteImport.update({
  id: '/content/settings',
  path: '/content/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDirectoryIndexRoute = AdminDirectoryIndexRouteImport.update({
  id: '/directory/',
  path: '/directory/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDisputesIndexRoute = AdminDisputesIndexRouteImport.update({
  id: '/disputes/',
  path: '/disputes/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOperationsRfqRoute = AdminOperationsRfqRouteImport.update({
  id: '/operations/rfq',
  path: '/operations/rfq',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrgsIndexRoute = AdminOrgsIndexRouteImport.update({
  id: '/orgs/',
  path: '/orgs/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrgsIdRoute = AdminOrgsIdRouteImport.update({
  id: '/orgs/$id',
  path: '/orgs/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlansIndexRoute = AdminPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlansIdRoute = AdminPlansIdRouteImport.update({
  id: '/plans/$id',
  path: '/plans/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsageIndexRoute = AdminUsageIndexRouteImport.update({
  id: '/usage/',
  path: '/usage/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsageOrgIdRoute = AdminUsageOrgIdRouteImport.update({
  id: '/usage/$orgId',
  path: '/usage/$orgId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVerificationIndexRoute = AdminVerificationIndexRouteImport.update({
  id: '/verification/',
  path: '/verification/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVerificationOrgIdRoute = AdminVerificationOrgIdRouteImport.update({
  id: '/verification/$orgId',
  path: '/verification/$orgId',
  getParentRoute: () => AdminRoute,
} as any)
const PortalBillingIndexRoute = PortalBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalBillingPlansRoute = PortalBillingPlansRouteImport.update({
  id: '/billing/plans',
  path: '/billing/plans',
  getParentRoute: () => PortalRoute,
} as any)
const PortalBillsIndexRoute = PortalBillsIndexRouteImport.update({
  id: '/bills/',
  path: '/bills/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalCatalogueIndexRoute = PortalCatalogueIndexRouteImport.update({
  id: '/catalogue/',
  path: '/catalogue/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalCatalogueChargeItemsRoute =
  PortalCatalogueChargeItemsRouteImport.update({
    id: '/catalogue/charge-items',
    path: '/catalogue/charge-items',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalCatalogueFeeBundlesRoute =
  PortalCatalogueFeeBundlesRouteImport.update({
    id: '/catalogue/fee-bundles',
    path: '/catalogue/fee-bundles',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalCatalogueFxRoute = PortalCatalogueFxRouteImport.update({
  id: '/catalogue/fx',
  path: '/catalogue/fx',
  getParentRoute: () => PortalRoute,
} as any)
const PortalClassifierIndexRoute = PortalClassifierIndexRouteImport.update({
  id: '/classifier/',
  path: '/classifier/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalCompaniesSlugRoute = PortalCompaniesSlugRouteImport.update({
  id: '/companies/$slug',
  path: '/companies/$slug',
  getParentRoute: () => PortalRoute,
} as any)
const PortalConnectionsIndexRoute = PortalConnectionsIndexRouteImport.update({
  id: '/connections/',
  path: '/connections/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalConnectionsIdRoute = PortalConnectionsIdRouteImport.update({
  id: '/connections/$id',
  path: '/connections/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDirectoryIndexRoute = PortalDirectoryIndexRouteImport.update({
  id: '/directory/',
  path: '/directory/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDirectoryOrgIdRoute = PortalDirectoryOrgIdRouteImport.update({
  id: '/directory/$orgId',
  path: '/directory/$orgId',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDirectoryProfileRoute = PortalDirectoryProfileRouteImport.update({
  id: '/directory/profile',
  path: '/directory/profile',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDisputesIndexRoute = PortalDisputesIndexRouteImport.update({
  id: '/disputes/',
  path: '/disputes/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDisputesIdRoute = PortalDisputesIdRouteImport.update({
  id: '/disputes/$id',
  path: '/disputes/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDocumentsIndexRoute = PortalDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDocumentsIdRoute = PortalDocumentsIdRouteImport.update({
  id: '/documents/$id',
  path: '/documents/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDocumentsLetterheadRoute =
  PortalDocumentsLetterheadRouteImport.update({
    id: '/documents/letterhead',
    path: '/documents/letterhead',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalDutyIndexRoute = PortalDutyIndexRouteImport.update({
  id: '/duty/',
  path: '/duty/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalEventsIndexRoute = PortalEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalEventsIdRoute = PortalEventsIdRouteImport.update({
  id: '/events/$id',
  path: '/events/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalInvoicesIndexRoute = PortalInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalMessagesIndexRoute = PortalMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalMessagesThreadIdRoute = PortalMessagesThreadIdRouteImport.update({
  id: '/messages/$threadId',
  path: '/messages/$threadId',
  getParentRoute: () => PortalRoute,
} as any)
const PortalOffersIndexRoute = PortalOffersIndexRouteImport.update({
  id: '/offers/',
  path: '/offers/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalOffersIdRoute = PortalOffersIdRouteImport.update({
  id: '/offers/$id',
  path: '/offers/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalOffersNewRoute = PortalOffersNewRouteImport.update({
  id: '/offers/new',
  path: '/offers/new',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPaymentRequestsIndexRoute =
  PortalPaymentRequestsIndexRouteImport.update({
    id: '/payment-requests/',
    path: '/payment-requests/',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalRatesIndexRoute = PortalRatesIndexRouteImport.update({
  id: '/rates/',
  path: '/rates/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRatesIdRoute = PortalRatesIdRouteImport.update({
  id: '/rates/$id',
  path: '/rates/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRatesMineRoute = PortalRatesMineRouteImport.update({
  id: '/rates/mine',
  path: '/rates/mine',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRatesSharingRoute = PortalRatesSharingRouteImport.update({
  id: '/rates/sharing',
  path: '/rates/sharing',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRatesSurchargesRoute = PortalRatesSurchargesRouteImport.update({
  id: '/rates/surcharges',
  path: '/rates/surcharges',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRfqIndexRoute = PortalRfqIndexRouteImport.update({
  id: '/rfq/',
  path: '/rfq/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRfqIdRoute = PortalRfqIdRouteImport.update({
  id: '/rfq/$id',
  path: '/rfq/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRfqNewRoute = PortalRfqNewRouteImport.update({
  id: '/rfq/new',
  path: '/rfq/new',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSettlementCashRoute = PortalSettlementCashRouteImport.update({
  id: '/settlement/cash',
  path: '/settlement/cash',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSettlementLedgerRoute = PortalSettlementLedgerRouteImport.update({
  id: '/settlement/ledger',
  path: '/settlement/ledger',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSettlementManualPaymentsRoute =
  PortalSettlementManualPaymentsRouteImport.update({
    id: '/settlement/manual-payments',
    path: '/settlement/manual-payments',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalSettlementPayRoute = PortalSettlementPayRouteImport.update({
  id: '/settlement/pay',
  path: '/settlement/pay',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSettlementReconciliationRoute =
  PortalSettlementReconciliationRouteImport.update({
    id: '/settlement/reconciliation',
    path: '/settlement/reconciliation',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalShipmentsIndexRoute = PortalShipmentsIndexRouteImport.update({
  id: '/shipments/',
  path: '/shipments/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalShipmentsIdRoute = PortalShipmentsIdRouteImport.update({
  id: '/shipments/$id',
  path: '/shipments/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalShipmentsBookingRoute = PortalShipmentsBookingRouteImport.update({
  id: '/shipments/booking',
  path: '/shipments/booking',
  getParentRoute: () => PortalRoute,
} as any)
const PortalShipmentsCollaborationRoute =
  PortalShipmentsCollaborationRouteImport.update({
    id: '/shipments/collaboration',
    path: '/shipments/collaboration',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalShipmentsNewRoute = PortalShipmentsNewRouteImport.update({
  id: '/shipments/new',
  path: '/shipments/new',
  getParentRoute: () => PortalRoute,
} as any)
const PortalTrackingIndexRoute = PortalTrackingIndexRouteImport.update({
  id: '/tracking/',
  path: '/tracking/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalTrackingPreferencesRoute =
  PortalTrackingPreferencesRouteImport.update({
    id: '/tracking/preferences',
    path: '/tracking/preferences',
    getParentRoute: () => PortalRoute,
  } as any)
const AdminCommunityEventsIdRoute = AdminCommunityEventsIdRouteImport.update({
  id: '/community/events/$id',
  path: '/community/events/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentPagesIdRoute = AdminContentPagesIdRouteImport.update({
  id: '/content/pages/$id',
  path: '/content/pages/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDirectoryProfilesOrgIdRoute =
  AdminDirectoryProfilesOrgIdRouteImport.update({
    id: '/directory/profiles/$orgId',
    path: '/directory/profiles/$orgId',
    getParentRoute: () => AdminRoute,
  } as any)
const PortalMessagesPopoutThreadIdRoute =
  PortalMessagesPopoutThreadIdRouteImport.update({
    id: '/messages/popout/$threadId',
    path: '/messages/popout/$threadId',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalRatesImportsIdRoute = PortalRatesImportsIdRouteImport.update({
  id: '/rates/imports/$id',
  path: '/rates/imports/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRatesQuotesIndexRoute = PortalRatesQuotesIndexRouteImport.update({
  id: '/rates/quotes/',
  path: '/rates/quotes/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRatesQuotesIdRoute = PortalRatesQuotesIdRouteImport.update({
  id: '/rates/quotes/$id',
  path: '/rates/quotes/$id',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSettlementWriteoffsIdRoute =
  PortalSettlementWriteoffsIdRouteImport.update({
    id: '/settlement/writeoffs/$id',
    path: '/settlement/writeoffs/$id',
    getParentRoute: () => PortalRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/lobby': typeof LobbyRoute
  '/onboarding': typeof OnboardingRoute
  '/portal': typeof PortalRouteWithChildren
  '/admin/addons': typeof AdminAddonsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/claims': typeof AdminClaimsRoute
  '/admin/credentials': typeof AdminCredentialsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/features': typeof AdminFeaturesRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/merge': typeof AdminMergeRoute
  '/admin/rates': typeof AdminRatesRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/sanctions': typeof AdminSanctionsRoute
  '/admin/seed': typeof AdminSeedRoute
  '/admin/settlement': typeof AdminSettlementRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/watchlist': typeof AdminWatchlistRoute
  '/content-preview/$id': typeof ContentPreviewIdRoute
  '/dev/ui': typeof DevUiRoute
  '/portal/announcements': typeof PortalAnnouncementsRoute
  '/portal/company': typeof PortalCompanyRoute
  '/portal/notifications': typeof PortalNotificationsRoute
  '/portal/team': typeof PortalTeamRoute
  '/portal/trust': typeof PortalTrustRoute
  '/portal/verification': typeof PortalVerificationRoute
  '/admin/': typeof AdminIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/bl-confirm/$token': typeof PublicBlConfirmTokenRoute
  '/c/$slug': typeof PublicCSlugRoute
  '/events/$slug': typeof PublicEventsSlugRoute
  '/quote/$token': typeof PublicQuoteTokenRoute
  '/sign-in/callback': typeof PublicSignInCallbackRoute
  '/admin/catalogue/fx': typeof AdminCatalogueFxRoute
  '/admin/catalogue/platform-charge-items': typeof AdminCataloguePlatformChargeItemsRoute
  '/admin/catalogue/reference': typeof AdminCatalogueReferenceRoute
  '/admin/content/media': typeof AdminContentMediaRoute
  '/admin/content/menus': typeof AdminContentMenusRoute
  '/admin/content/settings': typeof AdminContentSettingsRoute
  '/admin/operations/rfq': typeof AdminOperationsRfqRoute
  '/admin/orgs/$id': typeof AdminOrgsIdRoute
  '/admin/plans/$id': typeof AdminPlansIdRoute
  '/admin/usage/$orgId': typeof AdminUsageOrgIdRoute
  '/admin/verification/$orgId': typeof AdminVerificationOrgIdRoute
  '/portal/billing/plans': typeof PortalBillingPlansRoute
  '/portal/catalogue/charge-items': typeof PortalCatalogueChargeItemsRoute
  '/portal/catalogue/fee-bundles': typeof PortalCatalogueFeeBundlesRoute
  '/portal/catalogue/fx': typeof PortalCatalogueFxRoute
  '/portal/companies/$slug': typeof PortalCompaniesSlugRoute
  '/portal/connections/$id': typeof PortalConnectionsIdRoute
  '/portal/directory/$orgId': typeof PortalDirectoryOrgIdRoute
  '/portal/directory/profile': typeof PortalDirectoryProfileRoute
  '/portal/disputes/$id': typeof PortalDisputesIdRoute
  '/portal/documents/$id': typeof PortalDocumentsIdRoute
  '/portal/documents/letterhead': typeof PortalDocumentsLetterheadRoute
  '/portal/events/$id': typeof PortalEventsIdRoute
  '/portal/messages/$threadId': typeof PortalMessagesThreadIdRoute
  '/portal/offers/$id': typeof PortalOffersIdRoute
  '/portal/offers/new': typeof PortalOffersNewRoute
  '/portal/rates/$id': typeof PortalRatesIdRoute
  '/portal/rates/mine': typeof PortalRatesMineRoute
  '/portal/rates/sharing': typeof PortalRatesSharingRoute
  '/portal/rates/surcharges': typeof PortalRatesSurchargesRoute
  '/portal/rfq/$id': typeof PortalRfqIdRoute
  '/portal/rfq/new': typeof PortalRfqNewRoute
  '/portal/settlement/cash': typeof PortalSettlementCashRoute
  '/portal/settlement/ledger': typeof PortalSettlementLedgerRoute
  '/portal/settlement/manual-payments': typeof PortalSettlementManualPaymentsRoute
  '/portal/settlement/pay': typeof PortalSettlementPayRoute
  '/portal/settlement/reconciliation': typeof PortalSettlementReconciliationRoute
  '/portal/shipments/$id': typeof PortalShipmentsIdRoute
  '/portal/shipments/booking': typeof PortalShipmentsBookingRoute
  '/portal/shipments/collaboration': typeof PortalShipmentsCollaborationRoute
  '/portal/shipments/new': typeof PortalShipmentsNewRoute
  '/portal/tracking/preferences': typeof PortalTrackingPreferencesRoute
  '/events/': typeof PublicEventsIndexRoute
  '/sign-in/': typeof PublicSignInIndexRoute
  '/admin/catalogue/': typeof AdminCatalogueIndexRoute
  '/admin/community/': typeof AdminCommunityIndexRoute
  '/admin/content/': typeof AdminContentIndexRoute
  '/admin/directory/': typeof AdminDirectoryIndexRoute
  '/admin/disputes/': typeof AdminDisputesIndexRoute
  '/admin/orgs/': typeof AdminOrgsIndexRoute
  '/admin/plans/': typeof AdminPlansIndexRoute
  '/admin/usage/': typeof AdminUsageIndexRoute
  '/admin/verification/': typeof AdminVerificationIndexRoute
  '/portal/billing/': typeof PortalBillingIndexRoute
  '/portal/bills/': typeof PortalBillsIndexRoute
  '/portal/catalogue/': typeof PortalCatalogueIndexRoute
  '/portal/classifier/': typeof PortalClassifierIndexRoute
  '/portal/connections/': typeof PortalConnectionsIndexRoute
  '/portal/directory/': typeof PortalDirectoryIndexRoute
  '/portal/disputes/': typeof PortalDisputesIndexRoute
  '/portal/documents/': typeof PortalDocumentsIndexRoute
  '/portal/duty/': typeof PortalDutyIndexRoute
  '/portal/events/': typeof PortalEventsIndexRoute
  '/portal/invoices/': typeof PortalInvoicesIndexRoute
  '/portal/messages/': typeof PortalMessagesIndexRoute
  '/portal/offers/': typeof PortalOffersIndexRoute
  '/portal/payment-requests/': typeof PortalPaymentRequestsIndexRoute
  '/portal/rates/': typeof PortalRatesIndexRoute
  '/portal/rfq/': typeof PortalRfqIndexRoute
  '/portal/shipments/': typeof PortalShipmentsIndexRoute
  '/portal/tracking/': typeof PortalTrackingIndexRoute
  '/admin/community/events/$id': typeof AdminCommunityEventsIdRoute
  '/admin/content/pages/$id': typeof AdminContentPagesIdRoute
  '/admin/directory/profiles/$orgId': typeof AdminDirectoryProfilesOrgIdRoute
  '/portal/messages/popout/$threadId': typeof PortalMessagesPopoutThreadIdRoute
  '/portal/rates/imports/$id': typeof PortalRatesImportsIdRoute
  '/portal/rates/quotes/$id': typeof PortalRatesQuotesIdRoute
  '/portal/settlement/writeoffs/$id': typeof PortalSettlementWriteoffsIdRoute
  '/portal/rates/quotes/': typeof PortalRatesQuotesIndexRoute
}
export interface FileRoutesByTo {
  '/lobby': typeof LobbyRoute
  '/onboarding': typeof OnboardingRoute
  '/admin/addons': typeof AdminAddonsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/claims': typeof AdminClaimsRoute
  '/admin/credentials': typeof AdminCredentialsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/features': typeof AdminFeaturesRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/merge': typeof AdminMergeRoute
  '/admin/rates': typeof AdminRatesRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/sanctions': typeof AdminSanctionsRoute
  '/admin/seed': typeof AdminSeedRoute
  '/admin/settlement': typeof AdminSettlementRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/watchlist': typeof AdminWatchlistRoute
  '/content-preview/$id': typeof ContentPreviewIdRoute
  '/dev/ui': typeof DevUiRoute
  '/portal/announcements': typeof PortalAnnouncementsRoute
  '/portal/company': typeof PortalCompanyRoute
  '/portal/notifications': typeof PortalNotificationsRoute
  '/portal/team': typeof PortalTeamRoute
  '/portal/trust': typeof PortalTrustRoute
  '/portal/verification': typeof PortalVerificationRoute
  '/': typeof PublicIndexRoute
  '/admin': typeof AdminIndexRoute
  '/portal': typeof PortalIndexRoute
  '/bl-confirm/$token': typeof PublicBlConfirmTokenRoute
  '/c/$slug': typeof PublicCSlugRoute
  '/events/$slug': typeof PublicEventsSlugRoute
  '/quote/$token': typeof PublicQuoteTokenRoute
  '/sign-in/callback': typeof PublicSignInCallbackRoute
  '/admin/catalogue/fx': typeof AdminCatalogueFxRoute
  '/admin/catalogue/platform-charge-items': typeof AdminCataloguePlatformChargeItemsRoute
  '/admin/catalogue/reference': typeof AdminCatalogueReferenceRoute
  '/admin/content/media': typeof AdminContentMediaRoute
  '/admin/content/menus': typeof AdminContentMenusRoute
  '/admin/content/settings': typeof AdminContentSettingsRoute
  '/admin/operations/rfq': typeof AdminOperationsRfqRoute
  '/admin/orgs/$id': typeof AdminOrgsIdRoute
  '/admin/plans/$id': typeof AdminPlansIdRoute
  '/admin/usage/$orgId': typeof AdminUsageOrgIdRoute
  '/admin/verification/$orgId': typeof AdminVerificationOrgIdRoute
  '/portal/billing/plans': typeof PortalBillingPlansRoute
  '/portal/catalogue/charge-items': typeof PortalCatalogueChargeItemsRoute
  '/portal/catalogue/fee-bundles': typeof PortalCatalogueFeeBundlesRoute
  '/portal/catalogue/fx': typeof PortalCatalogueFxRoute
  '/portal/companies/$slug': typeof PortalCompaniesSlugRoute
  '/portal/connections/$id': typeof PortalConnectionsIdRoute
  '/portal/directory/$orgId': typeof PortalDirectoryOrgIdRoute
  '/portal/directory/profile': typeof PortalDirectoryProfileRoute
  '/portal/disputes/$id': typeof PortalDisputesIdRoute
  '/portal/documents/$id': typeof PortalDocumentsIdRoute
  '/portal/documents/letterhead': typeof PortalDocumentsLetterheadRoute
  '/portal/events/$id': typeof PortalEventsIdRoute
  '/portal/messages/$threadId': typeof PortalMessagesThreadIdRoute
  '/portal/offers/$id': typeof PortalOffersIdRoute
  '/portal/offers/new': typeof PortalOffersNewRoute
  '/portal/rates/$id': typeof PortalRatesIdRoute
  '/portal/rates/mine': typeof PortalRatesMineRoute
  '/portal/rates/sharing': typeof PortalRatesSharingRoute
  '/portal/rates/surcharges': typeof PortalRatesSurchargesRoute
  '/portal/rfq/$id': typeof PortalRfqIdRoute
  '/portal/rfq/new': typeof PortalRfqNewRoute
  '/portal/settlement/cash': typeof PortalSettlementCashRoute
  '/portal/settlement/ledger': typeof PortalSettlementLedgerRoute
  '/portal/settlement/manual-payments': typeof PortalSettlementManualPaymentsRoute
  '/portal/settlement/pay': typeof PortalSettlementPayRoute
  '/portal/settlement/reconciliation': typeof PortalSettlementReconciliationRoute
  '/portal/shipments/$id': typeof PortalShipmentsIdRoute
  '/portal/shipments/booking': typeof PortalShipmentsBookingRoute
  '/portal/shipments/collaboration': typeof PortalShipmentsCollaborationRoute
  '/portal/shipments/new': typeof PortalShipmentsNewRoute
  '/portal/tracking/preferences': typeof PortalTrackingPreferencesRoute
  '/events': typeof PublicEventsIndexRoute
  '/sign-in': typeof PublicSignInIndexRoute
  '/admin/catalogue': typeof AdminCatalogueIndexRoute
  '/admin/community': typeof AdminCommunityIndexRoute
  '/admin/content': typeof AdminContentIndexRoute
  '/admin/directory': typeof AdminDirectoryIndexRoute
  '/admin/disputes': typeof AdminDisputesIndexRoute
  '/admin/orgs': typeof AdminOrgsIndexRoute
  '/admin/plans': typeof AdminPlansIndexRoute
  '/admin/usage': typeof AdminUsageIndexRoute
  '/admin/verification': typeof AdminVerificationIndexRoute
  '/portal/billing': typeof PortalBillingIndexRoute
  '/portal/bills': typeof PortalBillsIndexRoute
  '/portal/catalogue': typeof PortalCatalogueIndexRoute
  '/portal/classifier': typeof PortalClassifierIndexRoute
  '/portal/connections': typeof PortalConnectionsIndexRoute
  '/portal/directory': typeof PortalDirectoryIndexRoute
  '/portal/disputes': typeof PortalDisputesIndexRoute
  '/portal/documents': typeof PortalDocumentsIndexRoute
  '/portal/duty': typeof PortalDutyIndexRoute
  '/portal/events': typeof PortalEventsIndexRoute
  '/portal/invoices': typeof PortalInvoicesIndexRoute
  '/portal/messages': typeof PortalMessagesIndexRoute
  '/portal/offers': typeof PortalOffersIndexRoute
  '/portal/payment-requests': typeof PortalPaymentRequestsIndexRoute
  '/portal/rates': typeof PortalRatesIndexRoute
  '/portal/rfq': typeof PortalRfqIndexRoute
  '/portal/shipments': typeof PortalShipmentsIndexRoute
  '/portal/tracking': typeof PortalTrackingIndexRoute
  '/admin/community/events/$id': typeof AdminCommunityEventsIdRoute
  '/admin/content/pages/$id': typeof AdminContentPagesIdRoute
  '/admin/directory/profiles/$orgId': typeof AdminDirectoryProfilesOrgIdRoute
  '/portal/messages/popout/$threadId': typeof PortalMessagesPopoutThreadIdRoute
  '/portal/rates/imports/$id': typeof PortalRatesImportsIdRoute
  '/portal/rates/quotes/$id': typeof PortalRatesQuotesIdRoute
  '/portal/settlement/writeoffs/$id': typeof PortalSettlementWriteoffsIdRoute
  '/portal/rates/quotes': typeof PortalRatesQuotesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_public': typeof PublicRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/lobby': typeof LobbyRoute
  '/onboarding': typeof OnboardingRoute
  '/portal': typeof PortalRouteWithChildren
  '/admin/addons': typeof AdminAddonsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/claims': typeof AdminClaimsRoute
  '/admin/credentials': typeof AdminCredentialsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/features': typeof AdminFeaturesRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/merge': typeof AdminMergeRoute
  '/admin/rates': typeof AdminRatesRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/sanctions': typeof AdminSanctionsRoute
  '/admin/seed': typeof AdminSeedRoute
  '/admin/settlement': typeof AdminSettlementRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/watchlist': typeof AdminWatchlistRoute
  '/content-preview/$id': typeof ContentPreviewIdRoute
  '/dev/ui': typeof DevUiRoute
  '/portal/announcements': typeof PortalAnnouncementsRoute
  '/portal/company': typeof PortalCompanyRoute
  '/portal/notifications': typeof PortalNotificationsRoute
  '/portal/team': typeof PortalTeamRoute
  '/portal/trust': typeof PortalTrustRoute
  '/portal/verification': typeof PortalVerificationRoute
  '/_public/': typeof PublicIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/_public/bl-confirm/$token': typeof PublicBlConfirmTokenRoute
  '/_public/c/$slug': typeof PublicCSlugRoute
  '/_public/events/$slug': typeof PublicEventsSlugRoute
  '/_public/quote/$token': typeof PublicQuoteTokenRoute
  '/_public/sign-in/callback': typeof PublicSignInCallbackRoute
  '/admin/catalogue/fx': typeof AdminCatalogueFxRoute
  '/admin/catalogue/platform-charge-items': typeof AdminCataloguePlatformChargeItemsRoute
  '/admin/catalogue/reference': typeof AdminCatalogueReferenceRoute
  '/admin/content/media': typeof AdminContentMediaRoute
  '/admin/content/menus': typeof AdminContentMenusRoute
  '/admin/content/settings': typeof AdminContentSettingsRoute
  '/admin/operations/rfq': typeof AdminOperationsRfqRoute
  '/admin/orgs/$id': typeof AdminOrgsIdRoute
  '/admin/plans/$id': typeof AdminPlansIdRoute
  '/admin/usage/$orgId': typeof AdminUsageOrgIdRoute
  '/admin/verification/$orgId': typeof AdminVerificationOrgIdRoute
  '/portal/billing/plans': typeof PortalBillingPlansRoute
  '/portal/catalogue/charge-items': typeof PortalCatalogueChargeItemsRoute
  '/portal/catalogue/fee-bundles': typeof PortalCatalogueFeeBundlesRoute
  '/portal/catalogue/fx': typeof PortalCatalogueFxRoute
  '/portal/companies/$slug': typeof PortalCompaniesSlugRoute
  '/portal/connections/$id': typeof PortalConnectionsIdRoute
  '/portal/directory/$orgId': typeof PortalDirectoryOrgIdRoute
  '/portal/directory/profile': typeof PortalDirectoryProfileRoute
  '/portal/disputes/$id': typeof PortalDisputesIdRoute
  '/portal/documents/$id': typeof PortalDocumentsIdRoute
  '/portal/documents/letterhead': typeof PortalDocumentsLetterheadRoute
  '/portal/events/$id': typeof PortalEventsIdRoute
  '/portal/messages/$threadId': typeof PortalMessagesThreadIdRoute
  '/portal/offers/$id': typeof PortalOffersIdRoute
  '/portal/offers/new': typeof PortalOffersNewRoute
  '/portal/rates/$id': typeof PortalRatesIdRoute
  '/portal/rates/mine': typeof PortalRatesMineRoute
  '/portal/rates/sharing': typeof PortalRatesSharingRoute
  '/portal/rates/surcharges': typeof PortalRatesSurchargesRoute
  '/portal/rfq/$id': typeof PortalRfqIdRoute
  '/portal/rfq/new': typeof PortalRfqNewRoute
  '/portal/settlement/cash': typeof PortalSettlementCashRoute
  '/portal/settlement/ledger': typeof PortalSettlementLedgerRoute
  '/portal/settlement/manual-payments': typeof PortalSettlementManualPaymentsRoute
  '/portal/settlement/pay': typeof PortalSettlementPayRoute
  '/portal/settlement/reconciliation': typeof PortalSettlementReconciliationRoute
  '/portal/shipments/$id': typeof PortalShipmentsIdRoute
  '/portal/shipments/booking': typeof PortalShipmentsBookingRoute
  '/portal/shipments/collaboration': typeof PortalShipmentsCollaborationRoute
  '/portal/shipments/new': typeof PortalShipmentsNewRoute
  '/portal/tracking/preferences': typeof PortalTrackingPreferencesRoute
  '/_public/events/': typeof PublicEventsIndexRoute
  '/_public/sign-in/': typeof PublicSignInIndexRoute
  '/admin/catalogue/': typeof AdminCatalogueIndexRoute
  '/admin/community/': typeof AdminCommunityIndexRoute
  '/admin/content/': typeof AdminContentIndexRoute
  '/admin/directory/': typeof AdminDirectoryIndexRoute
  '/admin/disputes/': typeof AdminDisputesIndexRoute
  '/admin/orgs/': typeof AdminOrgsIndexRoute
  '/admin/plans/': typeof AdminPlansIndexRoute
  '/admin/usage/': typeof AdminUsageIndexRoute
  '/admin/verification/': typeof AdminVerificationIndexRoute
  '/portal/billing/': typeof PortalBillingIndexRoute
  '/portal/bills/': typeof PortalBillsIndexRoute
  '/portal/catalogue/': typeof PortalCatalogueIndexRoute
  '/portal/classifier/': typeof PortalClassifierIndexRoute
  '/portal/connections/': typeof PortalConnectionsIndexRoute
  '/portal/directory/': typeof PortalDirectoryIndexRoute
  '/portal/disputes/': typeof PortalDisputesIndexRoute
  '/portal/documents/': typeof PortalDocumentsIndexRoute
  '/portal/duty/': typeof PortalDutyIndexRoute
  '/portal/events/': typeof PortalEventsIndexRoute
  '/portal/invoices/': typeof PortalInvoicesIndexRoute
  '/portal/messages/': typeof PortalMessagesIndexRoute
  '/portal/offers/': typeof PortalOffersIndexRoute
  '/portal/payment-requests/': typeof PortalPaymentRequestsIndexRoute
  '/portal/rates/': typeof PortalRatesIndexRoute
  '/portal/rfq/': typeof PortalRfqIndexRoute
  '/portal/shipments/': typeof PortalShipmentsIndexRoute
  '/portal/tracking/': typeof PortalTrackingIndexRoute
  '/admin/community/events/$id': typeof AdminCommunityEventsIdRoute
  '/admin/content/pages/$id': typeof AdminContentPagesIdRoute
  '/admin/directory/profiles/$orgId': typeof AdminDirectoryProfilesOrgIdRoute
  '/portal/messages/popout/$threadId': typeof PortalMessagesPopoutThreadIdRoute
  '/portal/rates/imports/$id': typeof PortalRatesImportsIdRoute
  '/portal/rates/quotes/$id': typeof PortalRatesQuotesIdRoute
  '/portal/settlement/writeoffs/$id': typeof PortalSettlementWriteoffsIdRoute
  '/portal/rates/quotes/': typeof PortalRatesQuotesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/lobby'
    | '/onboarding'
    | '/portal'
    | '/admin/addons'
    | '/admin/audit'
    | '/admin/claims'
    | '/admin/credentials'
    | '/admin/dashboard'
    | '/admin/features'
    | '/admin/jobs'
    | '/admin/merge'
    | '/admin/rates'
    | '/admin/reports'
    | '/admin/sanctions'
    | '/admin/seed'
    | '/admin/settlement'
    | '/admin/staff'
    | '/admin/watchlist'
    | '/content-preview/$id'
    | '/dev/ui'
    | '/portal/announcements'
    | '/portal/company'
    | '/portal/notifications'
    | '/portal/team'
    | '/portal/trust'
    | '/portal/verification'
    | '/admin/'
    | '/portal/'
    | '/bl-confirm/$token'
    | '/c/$slug'
    | '/events/$slug'
    | '/quote/$token'
    | '/sign-in/callback'
    | '/admin/catalogue/fx'
    | '/admin/catalogue/platform-charge-items'
    | '/admin/catalogue/reference'
    | '/admin/content/media'
    | '/admin/content/menus'
    | '/admin/content/settings'
    | '/admin/operations/rfq'
    | '/admin/orgs/$id'
    | '/admin/plans/$id'
    | '/admin/usage/$orgId'
    | '/admin/verification/$orgId'
    | '/portal/billing/plans'
    | '/portal/catalogue/charge-items'
    | '/portal/catalogue/fee-bundles'
    | '/portal/catalogue/fx'
    | '/portal/companies/$slug'
    | '/portal/connections/$id'
    | '/portal/directory/$orgId'
    | '/portal/directory/profile'
    | '/portal/disputes/$id'
    | '/portal/documents/$id'
    | '/portal/documents/letterhead'
    | '/portal/events/$id'
    | '/portal/messages/$threadId'
    | '/portal/offers/$id'
    | '/portal/offers/new'
    | '/portal/rates/$id'
    | '/portal/rates/mine'
    | '/portal/rates/sharing'
    | '/portal/rates/surcharges'
    | '/portal/rfq/$id'
    | '/portal/rfq/new'
    | '/portal/settlement/cash'
    | '/portal/settlement/ledger'
    | '/portal/settlement/manual-payments'
    | '/portal/settlement/pay'
    | '/portal/settlement/reconciliation'
    | '/portal/shipments/$id'
    | '/portal/shipments/booking'
    | '/portal/shipments/collaboration'
    | '/portal/shipments/new'
    | '/portal/tracking/preferences'
    | '/events/'
    | '/sign-in/'
    | '/admin/catalogue/'
    | '/admin/community/'
    | '/admin/content/'
    | '/admin/directory/'
    | '/admin/disputes/'
    | '/admin/orgs/'
    | '/admin/plans/'
    | '/admin/usage/'
    | '/admin/verification/'
    | '/portal/billing/'
    | '/portal/bills/'
    | '/portal/catalogue/'
    | '/portal/classifier/'
    | '/portal/connections/'
    | '/portal/directory/'
    | '/portal/disputes/'
    | '/portal/documents/'
    | '/portal/duty/'
    | '/portal/events/'
    | '/portal/invoices/'
    | '/portal/messages/'
    | '/portal/offers/'
    | '/portal/payment-requests/'
    | '/portal/rates/'
    | '/portal/rfq/'
    | '/portal/shipments/'
    | '/portal/tracking/'
    | '/admin/community/events/$id'
    | '/admin/content/pages/$id'
    | '/admin/directory/profiles/$orgId'
    | '/portal/messages/popout/$threadId'
    | '/portal/rates/imports/$id'
    | '/portal/rates/quotes/$id'
    | '/portal/settlement/writeoffs/$id'
    | '/portal/rates/quotes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/lobby'
    | '/onboarding'
    | '/admin/addons'
    | '/admin/audit'
    | '/admin/claims'
    | '/admin/credentials'
    | '/admin/dashboard'
    | '/admin/features'
    | '/admin/jobs'
    | '/admin/merge'
    | '/admin/rates'
    | '/admin/reports'
    | '/admin/sanctions'
    | '/admin/seed'
    | '/admin/settlement'
    | '/admin/staff'
    | '/admin/watchlist'
    | '/content-preview/$id'
    | '/dev/ui'
    | '/portal/announcements'
    | '/portal/company'
    | '/portal/notifications'
    | '/portal/team'
    | '/portal/trust'
    | '/portal/verification'
    | '/'
    | '/admin'
    | '/portal'
    | '/bl-confirm/$token'
    | '/c/$slug'
    | '/events/$slug'
    | '/quote/$token'
    | '/sign-in/callback'
    | '/admin/catalogue/fx'
    | '/admin/catalogue/platform-charge-items'
    | '/admin/catalogue/reference'
    | '/admin/content/media'
    | '/admin/content/menus'
    | '/admin/content/settings'
    | '/admin/operations/rfq'
    | '/admin/orgs/$id'
    | '/admin/plans/$id'
    | '/admin/usage/$orgId'
    | '/admin/verification/$orgId'
    | '/portal/billing/plans'
    | '/portal/catalogue/charge-items'
    | '/portal/catalogue/fee-bundles'
    | '/portal/catalogue/fx'
    | '/portal/companies/$slug'
    | '/portal/connections/$id'
    | '/portal/directory/$orgId'
    | '/portal/directory/profile'
    | '/portal/disputes/$id'
    | '/portal/documents/$id'
    | '/portal/documents/letterhead'
    | '/portal/events/$id'
    | '/portal/messages/$threadId'
    | '/portal/offers/$id'
    | '/portal/offers/new'
    | '/portal/rates/$id'
    | '/portal/rates/mine'
    | '/portal/rates/sharing'
    | '/portal/rates/surcharges'
    | '/portal/rfq/$id'
    | '/portal/rfq/new'
    | '/portal/settlement/cash'
    | '/portal/settlement/ledger'
    | '/portal/settlement/manual-payments'
    | '/portal/settlement/pay'
    | '/portal/settlement/reconciliation'
    | '/portal/shipments/$id'
    | '/portal/shipments/booking'
    | '/portal/shipments/collaboration'
    | '/portal/shipments/new'
    | '/portal/tracking/preferences'
    | '/events'
    | '/sign-in'
    | '/admin/catalogue'
    | '/admin/community'
    | '/admin/content'
    | '/admin/directory'
    | '/admin/disputes'
    | '/admin/orgs'
    | '/admin/plans'
    | '/admin/usage'
    | '/admin/verification'
    | '/portal/billing'
    | '/portal/bills'
    | '/portal/catalogue'
    | '/portal/classifier'
    | '/portal/connections'
    | '/portal/directory'
    | '/portal/disputes'
    | '/portal/documents'
    | '/portal/duty'
    | '/portal/events'
    | '/portal/invoices'
    | '/portal/messages'
    | '/portal/offers'
    | '/portal/payment-requests'
    | '/portal/rates'
    | '/portal/rfq'
    | '/portal/shipments'
    | '/portal/tracking'
    | '/admin/community/events/$id'
    | '/admin/content/pages/$id'
    | '/admin/directory/profiles/$orgId'
    | '/portal/messages/popout/$threadId'
    | '/portal/rates/imports/$id'
    | '/portal/rates/quotes/$id'
    | '/portal/settlement/writeoffs/$id'
    | '/portal/rates/quotes'
  id:
    | '__root__'
    | '/_public'
    | '/admin'
    | '/lobby'
    | '/onboarding'
    | '/portal'
    | '/admin/addons'
    | '/admin/audit'
    | '/admin/claims'
    | '/admin/credentials'
    | '/admin/dashboard'
    | '/admin/features'
    | '/admin/jobs'
    | '/admin/merge'
    | '/admin/rates'
    | '/admin/reports'
    | '/admin/sanctions'
    | '/admin/seed'
    | '/admin/settlement'
    | '/admin/staff'
    | '/admin/watchlist'
    | '/content-preview/$id'
    | '/dev/ui'
    | '/portal/announcements'
    | '/portal/company'
    | '/portal/notifications'
    | '/portal/team'
    | '/portal/trust'
    | '/portal/verification'
    | '/_public/'
    | '/admin/'
    | '/portal/'
    | '/_public/bl-confirm/$token'
    | '/_public/c/$slug'
    | '/_public/events/$slug'
    | '/_public/quote/$token'
    | '/_public/sign-in/callback'
    | '/admin/catalogue/fx'
    | '/admin/catalogue/platform-charge-items'
    | '/admin/catalogue/reference'
    | '/admin/content/media'
    | '/admin/content/menus'
    | '/admin/content/settings'
    | '/admin/operations/rfq'
    | '/admin/orgs/$id'
    | '/admin/plans/$id'
    | '/admin/usage/$orgId'
    | '/admin/verification/$orgId'
    | '/portal/billing/plans'
    | '/portal/catalogue/charge-items'
    | '/portal/catalogue/fee-bundles'
    | '/portal/catalogue/fx'
    | '/portal/companies/$slug'
    | '/portal/connections/$id'
    | '/portal/directory/$orgId'
    | '/portal/directory/profile'
    | '/portal/disputes/$id'
    | '/portal/documents/$id'
    | '/portal/documents/letterhead'
    | '/portal/events/$id'
    | '/portal/messages/$threadId'
    | '/portal/offers/$id'
    | '/portal/offers/new'
    | '/portal/rates/$id'
    | '/portal/rates/mine'
    | '/portal/rates/sharing'
    | '/portal/rates/surcharges'
    | '/portal/rfq/$id'
    | '/portal/rfq/new'
    | '/portal/settlement/cash'
    | '/portal/settlement/ledger'
    | '/portal/settlement/manual-payments'
    | '/portal/settlement/pay'
    | '/portal/settlement/reconciliation'
    | '/portal/shipments/$id'
    | '/portal/shipments/booking'
    | '/portal/shipments/collaboration'
    | '/portal/shipments/new'
    | '/portal/tracking/preferences'
    | '/_public/events/'
    | '/_public/sign-in/'
    | '/admin/catalogue/'
    | '/admin/community/'
    | '/admin/content/'
    | '/admin/directory/'
    | '/admin/disputes/'
    | '/admin/orgs/'
    | '/admin/plans/'
    | '/admin/usage/'
    | '/admin/verification/'
    | '/portal/billing/'
    | '/portal/bills/'
    | '/portal/catalogue/'
    | '/portal/classifier/'
    | '/portal/connections/'
    | '/portal/directory/'
    | '/portal/disputes/'
    | '/portal/documents/'
    | '/portal/duty/'
    | '/portal/events/'
    | '/portal/invoices/'
    | '/portal/messages/'
    | '/portal/offers/'
    | '/portal/payment-requests/'
    | '/portal/rates/'
    | '/portal/rfq/'
    | '/portal/shipments/'
    | '/portal/tracking/'
    | '/admin/community/events/$id'
    | '/admin/content/pages/$id'
    | '/admin/directory/profiles/$orgId'
    | '/portal/messages/popout/$threadId'
    | '/portal/rates/imports/$id'
    | '/portal/rates/quotes/$id'
    | '/portal/settlement/writeoffs/$id'
    | '/portal/rates/quotes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PublicRoute: typeof PublicRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  LobbyRoute: typeof LobbyRoute
  OnboardingRoute: typeof OnboardingRoute
  PortalRoute: typeof PortalRouteWithChildren
  ContentPreviewIdRoute: typeof ContentPreviewIdRoute
  DevUiRoute: typeof DevUiRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lobby': {
      id: '/lobby'
      path: '/lobby'
      fullPath: '/lobby'
      preLoaderRoute: typeof LobbyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/addons': {
      id: '/admin/addons'
      path: '/addons'
      fullPath: '/admin/addons'
      preLoaderRoute: typeof AdminAddonsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/claims': {
      id: '/admin/claims'
      path: '/claims'
      fullPath: '/admin/claims'
      preLoaderRoute: typeof AdminClaimsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/credentials': {
      id: '/admin/credentials'
      path: '/credentials'
      fullPath: '/admin/credentials'
      preLoaderRoute: typeof AdminCredentialsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/features': {
      id: '/admin/features'
      path: '/features'
      fullPath: '/admin/features'
      preLoaderRoute: typeof AdminFeaturesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs': {
      id: '/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AdminJobsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/merge': {
      id: '/admin/merge'
      path: '/merge'
      fullPath: '/admin/merge'
      preLoaderRoute: typeof AdminMergeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/rates': {
      id: '/admin/rates'
      path: '/rates'
      fullPath: '/admin/rates'
      preLoaderRoute: typeof AdminRatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sanctions': {
      id: '/admin/sanctions'
      path: '/sanctions'
      fullPath: '/admin/sanctions'
      preLoaderRoute: typeof AdminSanctionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/seed': {
      id: '/admin/seed'
      path: '/seed'
      fullPath: '/admin/seed'
      preLoaderRoute: typeof AdminSeedRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settlement': {
      id: '/admin/settlement'
      path: '/settlement'
      fullPath: '/admin/settlement'
      preLoaderRoute: typeof AdminSettlementRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/staff': {
      id: '/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AdminStaffRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/watchlist': {
      id: '/admin/watchlist'
      path: '/watchlist'
      fullPath: '/admin/watchlist'
      preLoaderRoute: typeof AdminWatchlistRouteImport
      parentRoute: typeof AdminRoute
    }
    '/content-preview/$id': {
      id: '/content-preview/$id'
      path: '/content-preview/$id'
      fullPath: '/content-preview/$id'
      preLoaderRoute: typeof ContentPreviewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/ui': {
      id: '/dev/ui'
      path: '/dev/ui'
      fullPath: '/dev/ui'
      preLoaderRoute: typeof DevUiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/announcements': {
      id: '/portal/announcements'
      path: '/announcements'
      fullPath: '/portal/announcements'
      preLoaderRoute: typeof PortalAnnouncementsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/company': {
      id: '/portal/company'
      path: '/company'
      fullPath: '/portal/company'
      preLoaderRoute: typeof PortalCompanyRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/notifications': {
      id: '/portal/notifications'
      path: '/notifications'
      fullPath: '/portal/notifications'
      preLoaderRoute: typeof PortalNotificationsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/team': {
      id: '/portal/team'
      path: '/team'
      fullPath: '/portal/team'
      preLoaderRoute: typeof PortalTeamRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/trust': {
      id: '/portal/trust'
      path: '/trust'
      fullPath: '/portal/trust'
      preLoaderRoute: typeof PortalTrustRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/verification': {
      id: '/portal/verification'
      path: '/verification'
      fullPath: '/portal/verification'
      preLoaderRoute: typeof PortalVerificationRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_public/bl-confirm/$token': {
      id: '/_public/bl-confirm/$token'
      path: '/bl-confirm/$token'
      fullPath: '/bl-confirm/$token'
      preLoaderRoute: typeof PublicBlConfirmTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/c/$slug': {
      id: '/_public/c/$slug'
      path: '/c/$slug'
      fullPath: '/c/$slug'
      preLoaderRoute: typeof PublicCSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/events/': {
      id: '/_public/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof PublicEventsIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/events/$slug': {
      id: '/_public/events/$slug'
      path: '/events/$slug'
      fullPath: '/events/$slug'
      preLoaderRoute: typeof PublicEventsSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/quote/$token': {
      id: '/_public/quote/$token'
      path: '/quote/$token'
      fullPath: '/quote/$token'
      preLoaderRoute: typeof PublicQuoteTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in/': {
      id: '/_public/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof PublicSignInIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in/callback': {
      id: '/_public/sign-in/callback'
      path: '/sign-in/callback'
      fullPath: '/sign-in/callback'
      preLoaderRoute: typeof PublicSignInCallbackRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/catalogue/': {
      id: '/admin/catalogue/'
      path: '/catalogue'
      fullPath: '/admin/catalogue/'
      preLoaderRoute: typeof AdminCatalogueIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/catalogue/fx': {
      id: '/admin/catalogue/fx'
      path: '/catalogue/fx'
      fullPath: '/admin/catalogue/fx'
      preLoaderRoute: typeof AdminCatalogueFxRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/catalogue/platform-charge-items': {
      id: '/admin/catalogue/platform-charge-items'
      path: '/catalogue/platform-charge-items'
      fullPath: '/admin/catalogue/platform-charge-items'
      preLoaderRoute: typeof AdminCataloguePlatformChargeItemsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/catalogue/reference': {
      id: '/admin/catalogue/reference'
      path: '/catalogue/reference'
      fullPath: '/admin/catalogue/reference'
      preLoaderRoute: typeof AdminCatalogueReferenceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/community/': {
      id: '/admin/community/'
      path: '/community'
      fullPath: '/admin/community/'
      preLoaderRoute: typeof AdminCommunityIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/content/': {
      id: '/admin/content/'
      path: '/content'
      fullPath: '/admin/content/'
      preLoaderRoute: typeof AdminContentIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/content/media': {
      id: '/admin/content/media'
      path: '/content/media'
      fullPath: '/admin/content/media'
      preLoaderRoute: typeof AdminContentMediaRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/content/menus': {
      id: '/admin/content/menus'
      path: '/content/menus'
      fullPath: '/admin/content/menus'
      preLoaderRoute: typeof AdminContentMenusRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/content/settings': {
      id: '/admin/content/settings'
      path: '/content/settings'
      fullPath: '/admin/content/settings'
      preLoaderRoute: typeof AdminContentSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/directory/': {
      id: '/admin/directory/'
      path: '/directory'
      fullPath: '/admin/directory/'
      preLoaderRoute: typeof AdminDirectoryIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/disputes/': {
      id: '/admin/disputes/'
      path: '/disputes'
      fullPath: '/admin/disputes/'
      preLoaderRoute: typeof AdminDisputesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/operations/rfq': {
      id: '/admin/operations/rfq'
      path: '/operations/rfq'
      fullPath: '/admin/operations/rfq'
      preLoaderRoute: typeof AdminOperationsRfqRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/orgs/': {
      id: '/admin/orgs/'
      path: '/orgs'
      fullPath: '/admin/orgs/'
      preLoaderRoute: typeof AdminOrgsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/orgs/$id': {
      id: '/admin/orgs/$id'
      path: '/orgs/$id'
      fullPath: '/admin/orgs/$id'
      preLoaderRoute: typeof AdminOrgsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/plans/': {
      id: '/admin/plans/'
      path: '/plans'
      fullPath: '/admin/plans/'
      preLoaderRoute: typeof AdminPlansIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/plans/$id': {
      id: '/admin/plans/$id'
      path: '/plans/$id'
      fullPath: '/admin/plans/$id'
      preLoaderRoute: typeof AdminPlansIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/usage/': {
      id: '/admin/usage/'
      path: '/usage'
      fullPath: '/admin/usage/'
      preLoaderRoute: typeof AdminUsageIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/usage/$orgId': {
      id: '/admin/usage/$orgId'
      path: '/usage/$orgId'
      fullPath: '/admin/usage/$orgId'
      preLoaderRoute: typeof AdminUsageOrgIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/verification/': {
      id: '/admin/verification/'
      path: '/verification'
      fullPath: '/admin/verification/'
      preLoaderRoute: typeof AdminVerificationIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/verification/$orgId': {
      id: '/admin/verification/$orgId'
      path: '/verification/$orgId'
      fullPath: '/admin/verification/$orgId'
      preLoaderRoute: typeof AdminVerificationOrgIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/portal/billing/': {
      id: '/portal/billing/'
      path: '/billing'
      fullPath: '/portal/billing/'
      preLoaderRoute: typeof PortalBillingIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/billing/plans': {
      id: '/portal/billing/plans'
      path: '/billing/plans'
      fullPath: '/portal/billing/plans'
      preLoaderRoute: typeof PortalBillingPlansRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/bills/': {
      id: '/portal/bills/'
      path: '/bills'
      fullPath: '/portal/bills/'
      preLoaderRoute: typeof PortalBillsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/catalogue/': {
      id: '/portal/catalogue/'
      path: '/catalogue'
      fullPath: '/portal/catalogue/'
      preLoaderRoute: typeof PortalCatalogueIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/catalogue/charge-items': {
      id: '/portal/catalogue/charge-items'
      path: '/catalogue/charge-items'
      fullPath: '/portal/catalogue/charge-items'
      preLoaderRoute: typeof PortalCatalogueChargeItemsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/catalogue/fee-bundles': {
      id: '/portal/catalogue/fee-bundles'
      path: '/catalogue/fee-bundles'
      fullPath: '/portal/catalogue/fee-bundles'
      preLoaderRoute: typeof PortalCatalogueFeeBundlesRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/catalogue/fx': {
      id: '/portal/catalogue/fx'
      path: '/catalogue/fx'
      fullPath: '/portal/catalogue/fx'
      preLoaderRoute: typeof PortalCatalogueFxRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/classifier/': {
      id: '/portal/classifier/'
      path: '/classifier'
      fullPath: '/portal/classifier/'
      preLoaderRoute: typeof PortalClassifierIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/companies/$slug': {
      id: '/portal/companies/$slug'
      path: '/companies/$slug'
      fullPath: '/portal/companies/$slug'
      preLoaderRoute: typeof PortalCompaniesSlugRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/connections/': {
      id: '/portal/connections/'
      path: '/connections'
      fullPath: '/portal/connections/'
      preLoaderRoute: typeof PortalConnectionsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/connections/$id': {
      id: '/portal/connections/$id'
      path: '/connections/$id'
      fullPath: '/portal/connections/$id'
      preLoaderRoute: typeof PortalConnectionsIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/directory/': {
      id: '/portal/directory/'
      path: '/directory'
      fullPath: '/portal/directory/'
      preLoaderRoute: typeof PortalDirectoryIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/directory/$orgId': {
      id: '/portal/directory/$orgId'
      path: '/directory/$orgId'
      fullPath: '/portal/directory/$orgId'
      preLoaderRoute: typeof PortalDirectoryOrgIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/directory/profile': {
      id: '/portal/directory/profile'
      path: '/directory/profile'
      fullPath: '/portal/directory/profile'
      preLoaderRoute: typeof PortalDirectoryProfileRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/disputes/': {
      id: '/portal/disputes/'
      path: '/disputes'
      fullPath: '/portal/disputes/'
      preLoaderRoute: typeof PortalDisputesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/disputes/$id': {
      id: '/portal/disputes/$id'
      path: '/disputes/$id'
      fullPath: '/portal/disputes/$id'
      preLoaderRoute: typeof PortalDisputesIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/documents/': {
      id: '/portal/documents/'
      path: '/documents'
      fullPath: '/portal/documents/'
      preLoaderRoute: typeof PortalDocumentsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/documents/$id': {
      id: '/portal/documents/$id'
      path: '/documents/$id'
      fullPath: '/portal/documents/$id'
      preLoaderRoute: typeof PortalDocumentsIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/documents/letterhead': {
      id: '/portal/documents/letterhead'
      path: '/documents/letterhead'
      fullPath: '/portal/documents/letterhead'
      preLoaderRoute: typeof PortalDocumentsLetterheadRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/duty/': {
      id: '/portal/duty/'
      path: '/duty'
      fullPath: '/portal/duty/'
      preLoaderRoute: typeof PortalDutyIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/events/': {
      id: '/portal/events/'
      path: '/events'
      fullPath: '/portal/events/'
      preLoaderRoute: typeof PortalEventsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/events/$id': {
      id: '/portal/events/$id'
      path: '/events/$id'
      fullPath: '/portal/events/$id'
      preLoaderRoute: typeof PortalEventsIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/invoices/': {
      id: '/portal/invoices/'
      path: '/invoices'
      fullPath: '/portal/invoices/'
      preLoaderRoute: typeof PortalInvoicesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/messages/': {
      id: '/portal/messages/'
      path: '/messages'
      fullPath: '/portal/messages/'
      preLoaderRoute: typeof PortalMessagesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/messages/$threadId': {
      id: '/portal/messages/$threadId'
      path: '/messages/$threadId'
      fullPath: '/portal/messages/$threadId'
      preLoaderRoute: typeof PortalMessagesThreadIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/offers/': {
      id: '/portal/offers/'
      path: '/offers'
      fullPath: '/portal/offers/'
      preLoaderRoute: typeof PortalOffersIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/offers/$id': {
      id: '/portal/offers/$id'
      path: '/offers/$id'
      fullPath: '/portal/offers/$id'
      preLoaderRoute: typeof PortalOffersIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/offers/new': {
      id: '/portal/offers/new'
      path: '/offers/new'
      fullPath: '/portal/offers/new'
      preLoaderRoute: typeof PortalOffersNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/payment-requests/': {
      id: '/portal/payment-requests/'
      path: '/payment-requests'
      fullPath: '/portal/payment-requests/'
      preLoaderRoute: typeof PortalPaymentRequestsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rates/': {
      id: '/portal/rates/'
      path: '/rates'
      fullPath: '/portal/rates/'
      preLoaderRoute: typeof PortalRatesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rates/$id': {
      id: '/portal/rates/$id'
      path: '/rates/$id'
      fullPath: '/portal/rates/$id'
      preLoaderRoute: typeof PortalRatesIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rates/mine': {
      id: '/portal/rates/mine'
      path: '/rates/mine'
      fullPath: '/portal/rates/mine'
      preLoaderRoute: typeof PortalRatesMineRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rates/sharing': {
      id: '/portal/rates/sharing'
      path: '/rates/sharing'
      fullPath: '/portal/rates/sharing'
      preLoaderRoute: typeof PortalRatesSharingRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rates/surcharges': {
      id: '/portal/rates/surcharges'
      path: '/rates/surcharges'
      fullPath: '/portal/rates/surcharges'
      preLoaderRoute: typeof PortalRatesSurchargesRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rfq/': {
      id: '/portal/rfq/'
      path: '/rfq'
      fullPath: '/portal/rfq/'
      preLoaderRoute: typeof PortalRfqIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rfq/$id': {
      id: '/portal/rfq/$id'
      path: '/rfq/$id'
      fullPath: '/portal/rfq/$id'
      preLoaderRoute: typeof PortalRfqIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rfq/new': {
      id: '/portal/rfq/new'
      path: '/rfq/new'
      fullPath: '/portal/rfq/new'
      preLoaderRoute: typeof PortalRfqNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/settlement/cash': {
      id: '/portal/settlement/cash'
      path: '/settlement/cash'
      fullPath: '/portal/settlement/cash'
      preLoaderRoute: typeof PortalSettlementCashRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/settlement/ledger': {
      id: '/portal/settlement/ledger'
      path: '/settlement/ledger'
      fullPath: '/portal/settlement/ledger'
      preLoaderRoute: typeof PortalSettlementLedgerRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/settlement/manual-payments': {
      id: '/portal/settlement/manual-payments'
      path: '/settlement/manual-payments'
      fullPath: '/portal/settlement/manual-payments'
      preLoaderRoute: typeof PortalSettlementManualPaymentsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/settlement/pay': {
      id: '/portal/settlement/pay'
      path: '/settlement/pay'
      fullPath: '/portal/settlement/pay'
      preLoaderRoute: typeof PortalSettlementPayRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/settlement/reconciliation': {
      id: '/portal/settlement/reconciliation'
      path: '/settlement/reconciliation'
      fullPath: '/portal/settlement/reconciliation'
      preLoaderRoute: typeof PortalSettlementReconciliationRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/shipments/': {
      id: '/portal/shipments/'
      path: '/shipments'
      fullPath: '/portal/shipments/'
      preLoaderRoute: typeof PortalShipmentsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/shipments/$id': {
      id: '/portal/shipments/$id'
      path: '/shipments/$id'
      fullPath: '/portal/shipments/$id'
      preLoaderRoute: typeof PortalShipmentsIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/shipments/booking': {
      id: '/portal/shipments/booking'
      path: '/shipments/booking'
      fullPath: '/portal/shipments/booking'
      preLoaderRoute: typeof PortalShipmentsBookingRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/shipments/collaboration': {
      id: '/portal/shipments/collaboration'
      path: '/shipments/collaboration'
      fullPath: '/portal/shipments/collaboration'
      preLoaderRoute: typeof PortalShipmentsCollaborationRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/shipments/new': {
      id: '/portal/shipments/new'
      path: '/shipments/new'
      fullPath: '/portal/shipments/new'
      preLoaderRoute: typeof PortalShipmentsNewRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/tracking/': {
      id: '/portal/tracking/'
      path: '/tracking'
      fullPath: '/portal/tracking/'
      preLoaderRoute: typeof PortalTrackingIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/tracking/preferences': {
      id: '/portal/tracking/preferences'
      path: '/tracking/preferences'
      fullPath: '/portal/tracking/preferences'
      preLoaderRoute: typeof PortalTrackingPreferencesRouteImport
      parentRoute: typeof PortalRoute
    }
    '/admin/community/events/$id': {
      id: '/admin/community/events/$id'
      path: '/community/events/$id'
      fullPath: '/admin/community/events/$id'
      preLoaderRoute: typeof AdminCommunityEventsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/content/pages/$id': {
      id: '/admin/content/pages/$id'
      path: '/content/pages/$id'
      fullPath: '/admin/content/pages/$id'
      preLoaderRoute: typeof AdminContentPagesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/directory/profiles/$orgId': {
      id: '/admin/directory/profiles/$orgId'
      path: '/directory/profiles/$orgId'
      fullPath: '/admin/directory/profiles/$orgId'
      preLoaderRoute: typeof AdminDirectoryProfilesOrgIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/portal/messages/popout/$threadId': {
      id: '/portal/messages/popout/$threadId'
      path: '/messages/popout/$threadId'
      fullPath: '/portal/messages/popout/$threadId'
      preLoaderRoute: typeof PortalMessagesPopoutThreadIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rates/imports/$id': {
      id: '/portal/rates/imports/$id'
      path: '/rates/imports/$id'
      fullPath: '/portal/rates/imports/$id'
      preLoaderRoute: typeof PortalRatesImportsIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rates/quotes/': {
      id: '/portal/rates/quotes/'
      path: '/rates/quotes'
      fullPath: '/portal/rates/quotes/'
      preLoaderRoute: typeof PortalRatesQuotesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/rates/quotes/$id': {
      id: '/portal/rates/quotes/$id'
      path: '/rates/quotes/$id'
      fullPath: '/portal/rates/quotes/$id'
      preLoaderRoute: typeof PortalRatesQuotesIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/settlement/writeoffs/$id': {
      id: '/portal/settlement/writeoffs/$id'
      path: '/settlement/writeoffs/$id'
      fullPath: '/portal/settlement/writeoffs/$id'
      preLoaderRoute: typeof PortalSettlementWriteoffsIdRouteImport
      parentRoute: typeof PortalRoute
    }
  }
}

interface PublicRouteChildren {
  PublicIndexRoute: typeof PublicIndexRoute
  PublicBlConfirmTokenRoute: typeof PublicBlConfirmTokenRoute
  PublicCSlugRoute: typeof PublicCSlugRoute
  PublicEventsSlugRoute: typeof PublicEventsSlugRoute
  PublicQuoteTokenRoute: typeof PublicQuoteTokenRoute
  PublicSignInCallbackRoute: typeof PublicSignInCallbackRoute
  PublicEventsIndexRoute: typeof PublicEventsIndexRoute
  PublicSignInIndexRoute: typeof PublicSignInIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicIndexRoute: PublicIndexRoute,
  PublicBlConfirmTokenRoute: PublicBlConfirmTokenRoute,
  PublicCSlugRoute: PublicCSlugRoute,
  PublicEventsSlugRoute: PublicEventsSlugRoute,
  PublicQuoteTokenRoute: PublicQuoteTokenRoute,
  PublicSignInCallbackRoute: PublicSignInCallbackRoute,
  PublicEventsIndexRoute: PublicEventsIndexRoute,
  PublicSignInIndexRoute: PublicSignInIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface AdminRouteChildren {
  AdminAddonsRoute: typeof AdminAddonsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminClaimsRoute: typeof AdminClaimsRoute
  AdminCredentialsRoute: typeof AdminCredentialsRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminFeaturesRoute: typeof AdminFeaturesRoute
  AdminJobsRoute: typeof AdminJobsRoute
  AdminMergeRoute: typeof AdminMergeRoute
  AdminRatesRoute: typeof AdminRatesRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminSanctionsRoute: typeof AdminSanctionsRoute
  AdminSeedRoute: typeof AdminSeedRoute
  AdminSettlementRoute: typeof AdminSettlementRoute
  AdminStaffRoute: typeof AdminStaffRoute
  AdminWatchlistRoute: typeof AdminWatchlistRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCatalogueFxRoute: typeof AdminCatalogueFxRoute
  AdminCataloguePlatformChargeItemsRoute: typeof AdminCataloguePlatformChargeItemsRoute
  AdminCatalogueReferenceRoute: typeof AdminCatalogueReferenceRoute
  AdminContentMediaRoute: typeof AdminContentMediaRoute
  AdminContentMenusRoute: typeof AdminContentMenusRoute
  AdminContentSettingsRoute: typeof AdminContentSettingsRoute
  AdminOperationsRfqRoute: typeof AdminOperationsRfqRoute
  AdminOrgsIdRoute: typeof AdminOrgsIdRoute
  AdminPlansIdRoute: typeof AdminPlansIdRoute
  AdminUsageOrgIdRoute: typeof AdminUsageOrgIdRoute
  AdminVerificationOrgIdRoute: typeof AdminVerificationOrgIdRoute
  AdminCatalogueIndexRoute: typeof AdminCatalogueIndexRoute
  AdminCommunityIndexRoute: typeof AdminCommunityIndexRoute
  AdminContentIndexRoute: typeof AdminContentIndexRoute
  AdminDirectoryIndexRoute: typeof AdminDirectoryIndexRoute
  AdminDisputesIndexRoute: typeof AdminDisputesIndexRoute
  AdminOrgsIndexRoute: typeof AdminOrgsIndexRoute
  AdminPlansIndexRoute: typeof AdminPlansIndexRoute
  AdminUsageIndexRoute: typeof AdminUsageIndexRoute
  AdminVerificationIndexRoute: typeof AdminVerificationIndexRoute
  AdminCommunityEventsIdRoute: typeof AdminCommunityEventsIdRoute
  AdminContentPagesIdRoute: typeof AdminContentPagesIdRoute
  AdminDirectoryProfilesOrgIdRoute: typeof AdminDirectoryProfilesOrgIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAddonsRoute: AdminAddonsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminClaimsRoute: AdminClaimsRoute,
  AdminCredentialsRoute: AdminCredentialsRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminFeaturesRoute: AdminFeaturesRoute,
  AdminJobsRoute: AdminJobsRoute,
  AdminMergeRoute: AdminMergeRoute,
  AdminRatesRoute: AdminRatesRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminSanctionsRoute: AdminSanctionsRoute,
  AdminSeedRoute: AdminSeedRoute,
  AdminSettlementRoute: AdminSettlementRoute,
  AdminStaffRoute: AdminStaffRoute,
  AdminWatchlistRoute: AdminWatchlistRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCatalogueFxRoute: AdminCatalogueFxRoute,
  AdminCataloguePlatformChargeItemsRoute:
    AdminCataloguePlatformChargeItemsRoute,
  AdminCatalogueReferenceRoute: AdminCatalogueReferenceRoute,
  AdminContentMediaRoute: AdminContentMediaRoute,
  AdminContentMenusRoute: AdminContentMenusRoute,
  AdminContentSettingsRoute: AdminContentSettingsRoute,
  AdminOperationsRfqRoute: AdminOperationsRfqRoute,
  AdminOrgsIdRoute: AdminOrgsIdRoute,
  AdminPlansIdRoute: AdminPlansIdRoute,
  AdminUsageOrgIdRoute: AdminUsageOrgIdRoute,
  AdminVerificationOrgIdRoute: AdminVerificationOrgIdRoute,
  AdminCatalogueIndexRoute: AdminCatalogueIndexRoute,
  AdminCommunityIndexRoute: AdminCommunityIndexRoute,
  AdminContentIndexRoute: AdminContentIndexRoute,
  AdminDirectoryIndexRoute: AdminDirectoryIndexRoute,
  AdminDisputesIndexRoute: AdminDisputesIndexRoute,
  AdminOrgsIndexRoute: AdminOrgsIndexRoute,
  AdminPlansIndexRoute: AdminPlansIndexRoute,
  AdminUsageIndexRoute: AdminUsageIndexRoute,
  AdminVerificationIndexRoute: AdminVerificationIndexRoute,
  AdminCommunityEventsIdRoute: AdminCommunityEventsIdRoute,
  AdminContentPagesIdRoute: AdminContentPagesIdRoute,
  AdminDirectoryProfilesOrgIdRoute: AdminDirectoryProfilesOrgIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface PortalRouteChildren {
  PortalAnnouncementsRoute: typeof PortalAnnouncementsRoute
  PortalCompanyRoute: typeof PortalCompanyRoute
  PortalNotificationsRoute: typeof PortalNotificationsRoute
  PortalTeamRoute: typeof PortalTeamRoute
  PortalTrustRoute: typeof PortalTrustRoute
  PortalVerificationRoute: typeof PortalVerificationRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PortalBillingPlansRoute: typeof PortalBillingPlansRoute
  PortalCatalogueChargeItemsRoute: typeof PortalCatalogueChargeItemsRoute
  PortalCatalogueFeeBundlesRoute: typeof PortalCatalogueFeeBundlesRoute
  PortalCatalogueFxRoute: typeof PortalCatalogueFxRoute
  PortalCompaniesSlugRoute: typeof PortalCompaniesSlugRoute
  PortalConnectionsIdRoute: typeof PortalConnectionsIdRoute
  PortalDirectoryOrgIdRoute: typeof PortalDirectoryOrgIdRoute
  PortalDirectoryProfileRoute: typeof PortalDirectoryProfileRoute
  PortalDisputesIdRoute: typeof PortalDisputesIdRoute
  PortalDocumentsIdRoute: typeof PortalDocumentsIdRoute
  PortalDocumentsLetterheadRoute: typeof PortalDocumentsLetterheadRoute
  PortalEventsIdRoute: typeof PortalEventsIdRoute
  PortalMessagesThreadIdRoute: typeof PortalMessagesThreadIdRoute
  PortalOffersIdRoute: typeof PortalOffersIdRoute
  PortalOffersNewRoute: typeof PortalOffersNewRoute
  PortalRatesIdRoute: typeof PortalRatesIdRoute
  PortalRatesMineRoute: typeof PortalRatesMineRoute
  PortalRatesSharingRoute: typeof PortalRatesSharingRoute
  PortalRatesSurchargesRoute: typeof PortalRatesSurchargesRoute
  PortalRfqIdRoute: typeof PortalRfqIdRoute
  PortalRfqNewRoute: typeof PortalRfqNewRoute
  PortalSettlementCashRoute: typeof PortalSettlementCashRoute
  PortalSettlementLedgerRoute: typeof PortalSettlementLedgerRoute
  PortalSettlementManualPaymentsRoute: typeof PortalSettlementManualPaymentsRoute
  PortalSettlementPayRoute: typeof PortalSettlementPayRoute
  PortalSettlementReconciliationRoute: typeof PortalSettlementReconciliationRoute
  PortalShipmentsIdRoute: typeof PortalShipmentsIdRoute
  PortalShipmentsBookingRoute: typeof PortalShipmentsBookingRoute
  PortalShipmentsCollaborationRoute: typeof PortalShipmentsCollaborationRoute
  PortalShipmentsNewRoute: typeof PortalShipmentsNewRoute
  PortalTrackingPreferencesRoute: typeof PortalTrackingPreferencesRoute
  PortalBillingIndexRoute: typeof PortalBillingIndexRoute
  PortalBillsIndexRoute: typeof PortalBillsIndexRoute
  PortalCatalogueIndexRoute: typeof PortalCatalogueIndexRoute
  PortalClassifierIndexRoute: typeof PortalClassifierIndexRoute
  PortalConnectionsIndexRoute: typeof PortalConnectionsIndexRoute
  PortalDirectoryIndexRoute: typeof PortalDirectoryIndexRoute
  PortalDisputesIndexRoute: typeof PortalDisputesIndexRoute
  PortalDocumentsIndexRoute: typeof PortalDocumentsIndexRoute
  PortalDutyIndexRoute: typeof PortalDutyIndexRoute
  PortalEventsIndexRoute: typeof PortalEventsIndexRoute
  PortalInvoicesIndexRoute: typeof PortalInvoicesIndexRoute
  PortalMessagesIndexRoute: typeof PortalMessagesIndexRoute
  PortalOffersIndexRoute: typeof PortalOffersIndexRoute
  PortalPaymentRequestsIndexRoute: typeof PortalPaymentRequestsIndexRoute
  PortalRatesIndexRoute: typeof PortalRatesIndexRoute
  PortalRfqIndexRoute: typeof PortalRfqIndexRoute
  PortalShipmentsIndexRoute: typeof PortalShipmentsIndexRoute
  PortalTrackingIndexRoute: typeof PortalTrackingIndexRoute
  PortalMessagesPopoutThreadIdRoute: typeof PortalMessagesPopoutThreadIdRoute
  PortalRatesImportsIdRoute: typeof PortalRatesImportsIdRoute
  PortalRatesQuotesIdRoute: typeof PortalRatesQuotesIdRoute
  PortalSettlementWriteoffsIdRoute: typeof PortalSettlementWriteoffsIdRoute
  PortalRatesQuotesIndexRoute: typeof PortalRatesQuotesIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalAnnouncementsRoute: PortalAnnouncementsRoute,
  PortalCompanyRoute: PortalCompanyRoute,
  PortalNotificationsRoute: PortalNotificationsRoute,
  PortalTeamRoute: PortalTeamRoute,
  PortalTrustRoute: PortalTrustRoute,
  PortalVerificationRoute: PortalVerificationRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalBillingPlansRoute: PortalBillingPlansRoute,
  PortalCatalogueChargeItemsRoute: PortalCatalogueChargeItemsRoute,
  PortalCatalogueFeeBundlesRoute: PortalCatalogueFeeBundlesRoute,
  PortalCatalogueFxRoute: PortalCatalogueFxRoute,
  PortalCompaniesSlugRoute: PortalCompaniesSlugRoute,
  PortalConnectionsIdRoute: PortalConnectionsIdRoute,
  PortalDirectoryOrgIdRoute: PortalDirectoryOrgIdRoute,
  PortalDirectoryProfileRoute: PortalDirectoryProfileRoute,
  PortalDisputesIdRoute: PortalDisputesIdRoute,
  PortalDocumentsIdRoute: PortalDocumentsIdRoute,
  PortalDocumentsLetterheadRoute: PortalDocumentsLetterheadRoute,
  PortalEventsIdRoute: PortalEventsIdRoute,
  PortalMessagesThreadIdRoute: PortalMessagesThreadIdRoute,
  PortalOffersIdRoute: PortalOffersIdRoute,
  PortalOffersNewRoute: PortalOffersNewRoute,
  PortalRatesIdRoute: PortalRatesIdRoute,
  PortalRatesMineRoute: PortalRatesMineRoute,
  PortalRatesSharingRoute: PortalRatesSharingRoute,
  PortalRatesSurchargesRoute: PortalRatesSurchargesRoute,
  PortalRfqIdRoute: PortalRfqIdRoute,
  PortalRfqNewRoute: PortalRfqNewRoute,
  PortalSettlementCashRoute: PortalSettlementCashRoute,
  PortalSettlementLedgerRoute: PortalSettlementLedgerRoute,
  PortalSettlementManualPaymentsRoute: PortalSettlementManualPaymentsRoute,
  PortalSettlementPayRoute: PortalSettlementPayRoute,
  PortalSettlementReconciliationRoute: PortalSettlementReconciliationRoute,
  PortalShipmentsIdRoute: PortalShipmentsIdRoute,
  PortalShipmentsBookingRoute: PortalShipmentsBookingRoute,
  PortalShipmentsCollaborationRoute: PortalShipmentsCollaborationRoute,
  PortalShipmentsNewRoute: PortalShipmentsNewRoute,
  PortalTrackingPreferencesRoute: PortalTrackingPreferencesRoute,
  PortalBillingIndexRoute: PortalBillingIndexRoute,
  PortalBillsIndexRoute: PortalBillsIndexRoute,
  PortalCatalogueIndexRoute: PortalCatalogueIndexRoute,
  PortalClassifierIndexRoute: PortalClassifierIndexRoute,
  PortalConnectionsIndexRoute: PortalConnectionsIndexRoute,
  PortalDirectoryIndexRoute: PortalDirectoryIndexRoute,
  PortalDisputesIndexRoute: PortalDisputesIndexRoute,
  PortalDocumentsIndexRoute: PortalDocumentsIndexRoute,
  PortalDutyIndexRoute: PortalDutyIndexRoute,
  PortalEventsIndexRoute: PortalEventsIndexRoute,
  PortalInvoicesIndexRoute: PortalInvoicesIndexRoute,
  PortalMessagesIndexRoute: PortalMessagesIndexRoute,
  PortalOffersIndexRoute: PortalOffersIndexRoute,
  PortalPaymentRequestsIndexRoute: PortalPaymentRequestsIndexRoute,
  PortalRatesIndexRoute: PortalRatesIndexRoute,
  PortalRfqIndexRoute: PortalRfqIndexRoute,
  PortalShipmentsIndexRoute: PortalShipmentsIndexRoute,
  PortalTrackingIndexRoute: PortalTrackingIndexRoute,
  PortalMessagesPopoutThreadIdRoute: PortalMessagesPopoutThreadIdRoute,
  PortalRatesImportsIdRoute: PortalRatesImportsIdRoute,
  PortalRatesQuotesIdRoute: PortalRatesQuotesIdRoute,
  PortalSettlementWriteoffsIdRoute: PortalSettlementWriteoffsIdRoute,
  PortalRatesQuotesIndexRoute: PortalRatesQuotesIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PublicRoute: PublicRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  LobbyRoute: LobbyRoute,
  OnboardingRoute: OnboardingRoute,
  PortalRoute: PortalRouteWithChildren,
  ContentPreviewIdRoute: ContentPreviewIdRoute,
  DevUiRoute: DevUiRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
